@if (loadError()) {
<div class="row mb-3">
    <div class="col-12">
        <div class="panel">
            <div class="panel-body text-center text-muted py-5">
                <i class="fas fa-exclamation-circle fa-2x mb-3 d-block opacity-50"></i>
                No se encontró el proceso solicitado.
                <div class="mt-3">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeEditor()">
                        <i class="fas fa-times me-1"></i> Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
} @else if (selectedProcess) {
<div class="row mb-3">
    <div class="col-12">
        <div class="panel animate__animated animate__fadeIn">
            <div class="panel-heading flex-wrap gap-2">
                <h4 class="panel-title d-flex align-items-center flex-wrap gap-2 mb-0">
                    <span>Flujo de Estados: <span class="text-primary">{{ selectedProcess.name }}</span></span>
                    @if (saveStatus() === 'pending') {
                        <span class="badge border text-warning fw-normal">
                            <i class="fas fa-pen me-1"></i>Sin guardar
                        </span>
                    } @else if (saveStatus() === 'saving') {
                        <span class="badge border text-muted fw-normal">
                            <i class="fas fa-spinner fa-spin me-1"></i>Guardando…
                        </span>
                    } @else if (saveStatus() === 'saved') {
                        <span class="badge border border-success text-success fw-normal">
                            <i class="fas fa-check me-1"></i>Guardado
                        </span>
                    } @else if (saveStatus() === 'error') {
                        <span class="badge border border-danger text-danger fw-normal">
                            <i class="fas fa-exclamation-circle me-1"></i>Error al guardar
                        </span>
                    }
                </h4>
                <div class="panel-heading-btn d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-primary btn-sm"
                        (click)="saveFlow()"
                        [disabled]="saveStatus() === 'saving' || currentFlows.length === 0">
                        <i class="fas fa-save me-1"></i> Guardar flujo
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="addStep()">
                        <i class="fas fa-plus me-1"></i> Agregar Paso al Flujo
                    </button>
                </div>
            </div>
            @if (currentFlows.length > 0 && !appSettings.isMobile()) {
            <div class="panel-body pt-2 pb-3">
                <app-flow-diagram [flows]="currentFlows" />
            </div>
            }
        </div>

        <app-flow-step-list
            [flows]="currentFlows"
            [availableStatuses]="availableStatuses()"
            [availableRoles]="availableRoles()"
            [documentTypes]="documentTypes()"
            (changed)="markDirty()"
            (moveUp)="moveUp($event)"
            (moveDown)="moveDown($event)"
            (remove)="removeStep($event)" />
    </div>
</div>
}
